export { default as Dashboard } from './page'


// WEBPACK FOOTER //
// ./src/pages/dashboard/index.js